module.exports = __webpack_public_path__ + "img/banco-pichincha.bc2661bb.svg";